import axiosClient from "api/axios_client.js";

const apiBusinessTypeDirectory = {
  create: (payload) => axiosClient.post(`/directories/business-master/business-type/create`, payload),
  update: (id, payload) => axiosClient.put(`/directories/business-master/business-type/update/${id}`, payload),
  getById: (id) => axiosClient.get(`/directories/business-master/business-type/get-by-id/${id}`),
  updateStatus: (payload) => axiosClient.post(`/directories/business-master/business-type/update-status`, payload),

  getAllBusinessType: (payload) => axiosClient.post(`/directories/business-master/business-type/get-all`, payload),
  delete: (ids) => axiosClient.delete(`/directories/business-master/business-type/delete`, { data: { ids } }),
};

export default apiBusinessTypeDirectory;
